import BossModel from "@/models/BossModel";
import PlatinumPage from "@/models/PlatinumPage/PlatinumPage";
import Country from "@/models/Country/Country";
import Region from "@/models/Region/Region";
import PlatinumHotel from "@/models/PlatinumHotel/PlatinumHotel";

export default class PlatinumExperience extends BossModel {

    static apiUrl = 'platinum-experience';

    static entity = 'platinumExperiences';

    static fields() {
        return {
            id: this.number(null).nullable(),
            platinum_page_id: this.number(null),
            platinum_hotel_id: this.number(null),
            name: this.attr(null),
            country_id: this.number(null),
            region_id: this.number(null),
            platinumPage: this.belongsTo(PlatinumPage, 'platinum_page_id'),
            country: this.belongsTo(Country, 'country_id'),
            region: this.belongsTo(Region, 'region_id'),
            platinumHotel: this.belongsTo(PlatinumHotel, 'platinum_hotel_id'),
        }
    }
}
